import { Component, Input, OnInit } from '@angular/core';

import { Modal } from 'bootstrap';

import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-drivers-rate-set',
	templateUrl: './drivers-rate-set.component.html',
	styleUrls: ['./drivers-rate-set.component.css'],
})
export class DriversRateSetComponent implements OnInit {
	@Input() driver;
	data = {
		id: null,
		driver: null,
		dateFrom: null,
		dateTo: null,
		workRate: null,
		breakRate: null,
		otherRate: null,
	};
	error = {
		dateRange: false,
	};
	tableRows = [
		{ id: 'dateFrom', name: 'Data od' },
		{ id: 'dateTo', name: 'Data do' },
		{ id: 'workRate', name: 'Jezdna' },
		{ id: 'breakRate', name: 'Leżona' },
		{ id: 'otherRate', name: 'Inna' },
	];
	rates: Array<any> = [];
	isItemBefore = false;
	isItemAfter = false;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		private readonly date: DateService,
	) {}

	ngOnInit(): void {
		this.loadData();
	}

	private loadData() {
		this.loader.show();
		this.api.get(`/driver/driverRate/?driver=${this.driver}`, (result, error) => {
			this.rates = result.data;
		});
	}

	submit() {
		if (!this.data.id) {
			this.api.post(`/driver/driverRate/`, this.data, (result, error) => {
				if (error) {
					return;
				}
				this.loadData();
			});
		} else {
			this.api.put(`/driver/driverRate/${this.data.id}/`, this.data, (result, error) => {
				if (error) {
					return;
				}
				this.infobox.success('Zapisano');
				this.loadData();
			});
		}
		this.dialogClose();
	}

	openModal() {
		this.data = {
			id: null,
			driver: this.driver,
			dateFrom: this.date.now().date,
			dateTo: null,
			workRate: null,
			breakRate: null,
			otherRate: null,
		};
		this.isItemAfter = false;
		this.isItemBefore = this.rates.length > 0 ? true : false;
		if (this.isItemBefore) {
			const lastOwner = this.rates[this.rates.length - 1];
			if (!lastOwner.dateTo) {
				this.infobox.error('Uzupełnij datę końcową');
				return;
			}
			this.data.dateFrom = this.date.addDays(1, lastOwner.dateTo);
		}
		new Modal(document.getElementById('rateSetModal')).show();
	}

	dialogClose() {
		const modal = Modal.getInstance(document.getElementById('rateSetModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	setRate(row) {
		this.data = this.rates.find((obj) => obj.id == row.id);
		const positionInArray = this.rates.indexOf(this.data);
		this.isItemBefore = positionInArray === 0 ? false : true;
		this.isItemAfter = positionInArray === this.rates.length - 1 ? false : true;
		new Modal(document.getElementById('rateSetModal')).show();
	}
}
